<template>
  <!-- 敏感词管理 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head">
        <el-button
          class="topAn"
          type="primary"
          size="mini"
          plain
          @click="addLibrary"
        >
          <i class="el-icon-plus"></i>添加敏感分类
        </el-button>
        <!-- 筛选 -->
        <div class="screening_box topAn">
          <el-input
            v-model="screenData.name"
            placeholder="请输入名称"
            clearable
            @change="search"
          ></el-input>
          <el-input
            v-model="screenData.keywords"
            placeholder="请输入关键词"
            clearable
            @change="search"
          ></el-input>
          <el-input
            v-model="screenData.code"
            placeholder="请输入code"
            clearable
            @change="search"
          ></el-input>
          <el-select
            v-model="screenData.companyId"
            filterable
            placeholder="请选择公司"
            :disabled="!isAdmin"
            @change="selectCompany"
          >
            <el-option
              :label="company.companyname"
              :value="company.companyid"
              v-for="company in search_companyList"
              :key="company.companyid"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!-- 敏感词列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column prop="code" label="code"> </el-table-column>
          <el-table-column label="关键词">
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                :title="scope.row.name + '关键词：'"
                width="1000"
                trigger="hover"
                :content="scope.row.keywords"
              >
                <div class="keywords" slot="reference">
                  {{ scope.row.keywords }}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column align="right" label="操作">
            <template slot-scope="scope">
              <div v-if="isAdmin">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <template>
                  <el-popconfirm
                    confirmButtonText="确定"
                    cancelButtonText="取消"
                    :hideIcon="true"
                    title="确定删除吗？"
                    @confirm="confirmDelete"
                  >
                    <el-button
                      slot="reference"
                      size="mini"
                      type="danger"
                      @click="handleDelete(scope.$index, scope.row)"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </div>
              <div v-else>
                <el-button
                  size="mini"
                  :disabled="scope.row.companyId != companyId"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <template>
                  <el-popconfirm
                    confirmButtonText="确定"
                    cancelButtonText="取消"
                    :hideIcon="true"
                    title="确定删除吗？"
                    @confirm="confirmDelete"
                  >
                    <el-button
                      slot="reference"
                      size="mini"
                      type="danger"
                      :disabled="scope.row.companyId != companyId"
                      @click="handleDelete(scope.$index, scope.row)"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="tableData"
        :page="page"
        :pageSize="pageSize"
        @change="changePage"
      />

      <!-- 添加/编辑敏感词 -->
      <el-dialog
        :title="is_add ? '添加敏感词' : '编辑敏感词'"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <!-- 名称 -->
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入名称"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 代码 -->
          <el-form-item label="代码" prop="code">
            <el-input
              v-model="ruleForm.code"
              placeholder="请输入代码"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 关键词 -->
          <el-form-item label="关键词" prop="keywords">
            <el-input
              :rows="3"
              type="textarea"
              v-model="ruleForm.keywords"
              placeholder="请输入关键词"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="公司" style="position: relative;">
            <el-select
              v-model="ruleForm.companyId"
              :disabled="!isAdmin"
              filterable
              placeholder="请选择公司"
            >
              <el-option
                :label="company.companyname"
                :value="company.companyid"
                v-for="company in company_list"
                :key="company.companyid"
              ></el-option>
            </el-select>
            <el-tooltip
              style="position: absolute;top: 14px;left: 35px;"
              effect="dark"
              content="不选择公司则为通用"
              placement="bottom"
              v-if="isAdmin"
            >
              <i class="el-icon-question" style="font-size: 14px;"></i>
            </el-tooltip>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="submitForm"
            >{{ is_add ? "确 定" : "保 存" }}</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import mixins from "../../../mixins";

export default {
  mixins: [mixins],
  data() {
    return {
      btnLoading: false,
      screenData: {
        name: "",
        keywords: "",
        code: "",
        companyId: ""
      },
      dialogFormVisible: false,
      is_add: true,
      // 表单
      ruleForm: {
        name: "",
        keywords: "",
        code: "",
        companyId: ""
      },
      // 表单检验规则
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        keywords: [
          { required: true, message: "请输入关键词", trigger: "blur" }
        ],
        code: [{ required: true, message: "请输入代码", trigger: "blur" }]
      },
      row_index: 0,
      library_id: "",
      dialog_top: "15vh",
      is_init: false,

      company_list: [], // 公司列表
      search_companyList: [] // 公司列表(筛选用)
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    companyId() {
      return this.$store.state.companyId;
    }
  },
  activated() {
    this.getCompanyList();
  },
  methods: {
    // 获取公司列表
    getCompanyList() {
      this.$http({
        url: this.$api.company_list
      }).then(res => {
        if (res.code == 0) {
          if (!this.isAdmin) {
            res.data.forEach(val => {
              if (this.companyId == val.companyid) {
                this.company_list = [val];
                this.search_companyList = [val];
              }
            });
          } else {
            this.company_list = JSON.parse(JSON.stringify(res.data));
            this.search_companyList = JSON.parse(JSON.stringify(res.data));
            this.search_companyList.unshift({
              companyid: "",
              companyname: "通用"
            });
            this.company_list.unshift({
              companyid: "",
              companyname: "不选择公司"
            });
          }
        }
      });
    },
    // 获取敏感词列表
    getList() {
      if (!this.authority) return;
      this.loading = true;
      if (!this.isAdmin) this.screenData.companyId = this.companyId;
      this.tableScrollTop();
      this.$http({
        url: this.$api.library_list,
        data: {
          name: this.screenData.name,
          keywords: this.screenData.keywords,
          code: this.screenData.code,
          companyId: this.screenData.companyId,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false;
        this.is_init = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.concent;
        }
      });
    },
    // 新增敏感词
    addLibraryReq(data) {
      this.btnLoading = true;
      this.$http({
        url: this.$api.add_library,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.is_init = true;
          this.screenData = {
            name: "",
            keywords: "",
            code: ""
          };
          this.page = 1;
          this.getList();
          this.$hint("添加成功");
        } else {
          this.$hint("添加失败", "err");
        }
      });
    },
    // 编辑敏感词
    editLibraryReq(data) {
      this.btnLoading = true;
      this.$http({
        url: this.$api.edit_library,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.$set(this.tableData, this.row_index, data);
          this.$hint("保存成功");
        } else {
          this.$hint("保存失败", "err");
        }
      });
    },
    // 删除敏感词
    delLibraryReq() {
      this.$http({
        url: this.$api.del_library + "/" + this.library_id,
        method: "get"
      }).then(res => {
        if (res.code == 0) {
          this.tableData.splice(this.row_index, 1);
          this.total--;
          this.$hint("删除成功");
        } else {
          this.$hint("删除失败", "err");
        }
      });
    },
    // 增加敏感词
    addLibrary() {
      this.dialogFormVisible = true;
      this.is_add = true;
      this.ruleForm = {
        name: "",
        keywords: "",
        code: "",
        companyId: ""
      };
      if (!this.isAdmin) this.ruleForm.companyId = this.companyId;
    },
    // 编辑敏感词
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.is_add = false;
      this.row_index = index;
      this.ruleForm = JSON.parse(JSON.stringify(row));
    },
    // 点击删除敏感词
    handleDelete(index, row) {
      this.library_id = row.id;
      this.row_index = index;
    },
    // 确定删除敏感词
    confirmDelete() {
      this.delLibraryReq();
    },
    // 确定新增、编辑
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let item = JSON.parse(JSON.stringify(this.ruleForm));
          if (this.is_add) {
            // 新增
            this.addLibraryReq(item);
          } else {
            // 编辑
            this.editLibraryReq(item);
          }
          this.cancel();
        } else {
          return false;
        }
      });
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    // 搜索
    search() {
      this.page = 1;
      this.getList();
    },
    // 选择公司（筛选）
    selectCompany(e) {
      this.screenData.companyId = e;
      this.getList();
    }
  }
};
</script>

<style></style>
<style lang="less" scoped>
.keywords {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/libraryList.vue